import React from "react";
import Navbar from "../../../components/main/navbar";
import Footer from "../../../components/main/footer";
import { Typography, Grid2 } from "@mui/material";
import Mission from "../../../images/mission.svg";
import Team from "../../../images/team.svg";

const AboutUs = () => {
  return (
    <div>
      <Navbar />
      <Grid2 bgcolor="#f8f9fc">
        <Grid2 container justifyContent="space-evenly" p={2} px={6}>
          <Grid2 xs={6}>
            <img
              src={`${Mission}`}
              height="300px"
              width="350px"
              alt="Success!"
            />
          </Grid2>
          <Grid2 xs={6} width="500px" alignContent="center" spacing={2}>
            <Typography
              fontFamily="General Sans Regular"
              variant="h3"
              fontSize="20px"
              color="#146aff"
              flexWrap="wrap"
              display="flex"
            >
              {" "}
              Notre mission{" "}
            </Typography>

            <Typography
              fontFamily="General Sans Regular"
              variant="body2"
              color="#146aff"
              maxWidth="500px"
              fontWeight="700"
              marginTop="20px"
            >
              {" "}
              SmartCandidate est une application intelligente dédiée à la
              création de lettres de motivation personnalisées selon les
              exigences de chaque poste. Elle aide les candidats à personnaliser
              leurs candidatures en fonction de leurs expériences et des
              attentes des recruteurs. Avec SmartCandidate, préparez
              parfaitement vos documents de candidature et augmentez vos chances
              de succès. Notre plateforme adapte votre profil pour correspondre
              aux descriptions de poste spécifiques, vous faisant gagner du
              temps et maximisant l'impact. Démarquez-vous sans effort et
              présentez votre meilleur visage aux employeurs potentiels.{" "}
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2 container justifyContent="space-evenly" p={2} px={6}>
          <Grid2 xs={6} width="500px" alignContent="center" spacing={2}>
            <Typography
              fontFamily="General Sans Regular"
              variant="h3"
              fontSize="20px"
              color="#146aff"
              flexWrap="wrap"
              display="flex"
            >
              {" "}
              Notre équipe{" "}
            </Typography>

            <Typography
              fontFamily="General Sans Regular"
              variant="body2"
              color="#146aff"
              maxWidth="500px"
              fontWeight="700"
              marginTop="20px"
            >
              {" "}
              Notre équipe est dédiée à la construction d'une solution puissante
              et axée sur l'utilisateur qui soutient les candidats à chaque
              étape de leur recherche d'emploi. Composée de professionnels
              passionnés dans les domaines de la technologie, du recrutement et
              du design, nous nous engageons à simplifier et améliorer le
              processus de candidature. Nous croyons en l'amélioration continue,
              motivée par les retours de nos utilisateurs, pour rendre
              SmartCandidate est le meilleur outil pour créer des candidatures
              remarquables. Avec un objectif commun d'accompagner les chercheurs
              d'emploi, nous travaillons sans relâche pour fournir une
              expérience intelligente, intuitive et impactante.{" "}
            </Typography>
          </Grid2>
          <Grid2 xs={6}>
            <img src={`${Team}`} height="300px" width="350px" alt="Success!" />
          </Grid2>
        </Grid2>
      </Grid2>

      <Footer />
    </div>
  );
};

export default AboutUs;
